import { render, staticRenderFns } from "./centralYunnan.vue?vue&type=template&id=45fd6541&scoped=true"
import script from "./centralYunnan.vue?vue&type=script&lang=js"
export * from "./centralYunnan.vue?vue&type=script&lang=js"
import style0 from "./centralYunnan.vue?vue&type=style&index=0&id=45fd6541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd6541",
  null
  
)

export default component.exports